<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="474">
    <v-img height="250" :src="image04"></v-img>

    <v-card-title>Seja nosso patrocinador</v-card-title>

    <v-card-text>
      <!--
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>

      <div class="my-4 subtitle-1 black--text">
        $ • Patrocinio, Apoio, Suporte
      </div>
-->

      <div>
        O
        <span style="font-family: 'Fontdiner Swanky', serif;"
          >VIOLENT NOISE</span
        >
        é um espaço independente e feito para os fãs e músicos das bandas. Sua
        ajuda será muito bem-vinda, pois isso irá auxiliar nos custos de
        manutenção do site.
      </div>
      <div>
        <i>Quer e pode contribuir?</i>
      </div>
      <div>
        Recebemos seu apoio através do Mercado Pago e/ou PicPay. Acesse seu aplicativo preferido, leia o QRCode e nos apoie no valor que você quiser.
      </div>
    </v-card-text>

    <v-divider class="mx-4"></v-divider>

    <v-card-title>Formas de Apoio</v-card-title>

    <v-card-text>
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab>
          <v-img max-width="150" :src="imagemp"></v-img>
        </v-tab>
        <v-tab>
          <v-img max-width="150" :src="imagepp"></v-img>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-img :src="imageqrmp"></v-img>
        </v-tab-item>
        <v-tab-item>
          <v-img :src="imageqrpp"></v-img>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <v-card-actions>
      <!--
      <v-btn color="deep-purple accent-4" text @click="dialog = false">
        Sair
      </v-btn>
      -->
    </v-card-actions>
  </v-card>
</template>

<script>
const mercadopago = require("@/assets/images/logos/mercado-pago.png");
const picpay = require("@/assets/images/logos/picpay.png");
const qrmercadopago = require("@/assets/images/logos/qrmercado-pago.png");
const qrpicpay = require("@/assets/images/logos/qrpicpay.png");
const image4 = require("@/assets/images/content/audio-cassette.jpg");

export default {
  data() {
    return {
      image04: image4,
      imagemp: mercadopago,
      imagepp: picpay,
      imageqrmp: qrmercadopago,
      imageqrpp: qrpicpay,
      loading: false,
      tab: null,
      items: ["MercadoPago", "PicPay"]
    };
  }
};
</script>

<style></style>
